export function onlyDigits(value: string) {
  return value.replace(/\D/g, '')
}

export function formatMoney(value: string | number | null | undefined) {
  if (value == null || value === '') return '—'
  const n = typeof value === 'number' ? value : Number(value)
  if (Number.isNaN(n)) return '—'
  return n.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
}

/** Parse BRL-ish input ("1.234,56", "1234,56", "R$ 10,00") → number; NaN if empty/invalid. */
export function parseMoney(value: string | number | null | undefined): number {
  if (value == null || value === '') return Number.NaN
  if (typeof value === 'number') return value
  let s = String(value).trim().replace(/[R$\s]/gi, '')
  if (!s) return Number.NaN
  if (s.includes(',')) {
    s = s.replace(/\./g, '').replace(',', '.')
  }
  return Number(s)
}

/** BRL display for salary input blur (e.g. "1.234,56"). */
export function formatMoneyInput(value: string | number | null | undefined): string {
  const n = parseMoney(value)
  if (Number.isNaN(n)) return value == null ? '' : String(value)
  return n.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
}

export function formatDate(iso?: string | null) {
  if (!iso) return '—'
  const d = new Date(iso.includes('T') ? iso : `${iso}T12:00:00`)
  if (Number.isNaN(d.getTime())) return iso
  return d.toLocaleDateString('pt-BR')
}

export function formatCpf(cpf?: string | null) {
  if (!cpf) return '—'
  const d = onlyDigits(cpf)
  if (d.length !== 11) return cpf
  return d.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')
}

/** Progressive CPF mask for inputs (digits only stored on submit). */
export function maskCpfInput(value: string): string {
  const d = onlyDigits(value).slice(0, 11)
  if (d.length <= 3) return d
  if (d.length <= 6) return `${d.slice(0, 3)}.${d.slice(3)}`
  if (d.length <= 9) return `${d.slice(0, 3)}.${d.slice(3, 6)}.${d.slice(6)}`
  return `${d.slice(0, 3)}.${d.slice(3, 6)}.${d.slice(6, 9)}-${d.slice(9)}`
}

/** Soft BR phone mask: (00) 0000-0000 or (00) 00000-0000. */
export function maskPhoneInput(value: string): string {
  const d = onlyDigits(value).slice(0, 11)
  if (d.length === 0) return ''
  if (d.length <= 2) return `(${d}`
  if (d.length <= 6) return `(${d.slice(0, 2)}) ${d.slice(2)}`
  if (d.length <= 10) return `(${d.slice(0, 2)}) ${d.slice(2, 6)}-${d.slice(6)}`
  return `(${d.slice(0, 2)}) ${d.slice(2, 7)}-${d.slice(7)}`
}

export function initials(nome?: string, fallback = '?') {
  if (!nome) return fallback
  const parts = nome.trim().split(/\s+/).filter(Boolean)
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase()
  return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase()
}
